import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "multiple"]

import {ref, useId, useTemplateRef} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'file',
  props: {
    multiple: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  },
  emits: ["update"],
  setup(__props, { expose: __expose, emit: __emit }) {

  

  const files = ref<Array<{
    data: string,
    extension: string,
    name: string
  }>>([])
  const emits = __emit
  const id = useId()
  const input = useTemplateRef("input")

  __expose({
    files
  })

  async function readFile(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = (event) => {
        let extension: string
        let name: string
        const fileNameSegments = file.name.match(/(.*)\.(.*)/)
        if (fileNameSegments.length && fileNameSegments.length < 3) {
          name = file.name
        } else {
          extension = fileNameSegments[2]
          name = fileNameSegments[1]
        }
        files.value.push({
          data: event.target.result.toString().split(",")[1],
          extension: extension,
          name: name
        })
        resolve()
      }
      fileReader.onerror = (event) => {
        reject(event)
      }
      fileReader.readAsDataURL(file)
    })
  }

  async function readFiles() {
    files.value = []
    for (const file of input.value.files) {
      await readFile(file)
    }
    emits("update")
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("label", { for: _unref(id) }, _toDisplayString(__props.title), 9, _hoisted_1),
      _createElementVNode("input", {
        id: _unref(id),
        ref_key: "input",
        ref: input,
        type: "file",
        multiple: __props.multiple,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (readFiles()))
      }, null, 40, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})